import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../Context/HimmaContext';



export const useStoreChoiceGroupApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


  const getStoreChoiceGroup = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        const response = await api.getChoiceGroups(
          query.storeId,
          searchParam
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );



  return {
   getStoreChoiceGroup,
    loading,
    error,
  };
};
